import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { changePageToCrateComplaintPreview, changePageToCreateComplaintPosition, changePageToCreateComplaintCustomer} from '../../actions/Page';
import { changeComplaintType } from '../../actions/Complaint';
import ComplaintPositonsList from './ComplaintPositionsList';
import {DeleteComplaintPosition} from '../../actions/ComplaintPositions';
import {fillComplaintPositionByObject} from '../../actions/ComplaintPosition';
import * as validator from '../../actions/Validators/ComplaintValidator';
import {clearError, throwNewError} from '../../actions/Error';

class ComplaintPositions extends Component {
    
    onCreateComplaintPositionButtonClick = () => {
        this.props.clearError();
        let validationResult = validator.validateComplaintType(this.props.complaint.complaintType.name);
        if (validationResult.isFromValid===true){
            this.props.changeWindowToComplaintPosition();
        } else {
            this.props.throwNewError("Błąd walidacji", validationResult.error);
        }
    }
  
    onNextButtonClick = () => {
        this.props.clearError();
        let validationResult = validator.validateIsAnyPosition(this.props.positions);
        if (validationResult.isFromValid===true){
            this.props.goToPreview();
        } else {
            this.props.throwNewError("Błąd walidacji", validationResult.error);
        }
    }

    onEditPositionBtnClick = (positionId) => {
        const position = this.props.positions.find(position => position.id == positionId);
        this.props.fillComplaintPositionByObject(position);
        this.props.changeWindowToComplaintPosition();
    }

    onDeletePositionBtnClick = (positionId) => {
        const position = this.props.positions.find(position => position.id == positionId);
        this.props.DeleteComplaintPosition(position);
    }

    onBackButtonClick = () => {
        this.props.goToCustomerPage();
    }

    onComplaintTypeChanged = (e) => {
        this.props.changeComplaintType({
            name: e.target.options[e.target.selectedIndex].getAttribute("name"),
            displayName: e.target.options[e.target.selectedIndex].text
        });
    }

    render(){
        const shouldSelectForComplaintTypeBeDisabled = this.props.positions.length > 0;
        const showFooter = (this.props.complaint.complaintType.name==="SalesWarranty");
        return(
            <div className="col-xs-12">
                <ComplaintPositonsList
                    complaintPositions={this.props.positions}
                    complaintType={this.props.complaint.complaintType}
                    complaintTypes={this.props.complaintTypes}
                    onDeletePositionBtnClick={this.onDeletePositionBtnClick}
                    onEditPositionBtnClick={this.onEditPositionBtnClick}
                    onComplaintTypeChanged={this.onComplaintTypeChanged}
                    onCreateComplaintPositionButtonClick={this.onCreateComplaintPositionButtonClick}
                    onBackButtonClick={this.onBackButtonClick}
                    onNextButtonClick={this.onNextButtonClick}
                    shouldSelectForComplaintTypeBeDisabled={shouldSelectForComplaintTypeBeDisabled} />
                {showFooter &&
                <div className="col-xs-12">
                    <hr /> 
                    {/* <p>Firma Pro Sp. z o.o. udziela 24-miesięcznej gwarancji tylko dla produktów z grupy Urządzeń laserowych i optycznych z wyłączeniem akcesoriów laserowych (tyczki, statywy, adaptery, łaty niwelacyjne), 10 letniej gwarancji na libelle dla produktów z grupy: Poziomnice, Łaty, Kątownice.<br /> Reklamacje na pozostałe produkty należy składać bezpośrednio u sprzedawcy.</p> */}
                </div>}
            </div>
        );
    }
} 
const mapStateToProps = (state) => {
    return {
        positions: state.complaintPositions.positions,
        complaintTypes: state.util.complaintTypes,
        complaint: state.complaint,
        error: state.error
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeWindowToComplaintPosition: () => dispatch(changePageToCreateComplaintPosition()),
        goToPreview: () => dispatch(changePageToCrateComplaintPreview()),
        changeComplaintType: (complaintType) => dispatch(changeComplaintType(complaintType)),
        goToCustomerPage: () => dispatch(changePageToCreateComplaintCustomer()),
        fillComplaintPositionByObject: (complaintPositon) => dispatch(fillComplaintPositionByObject(complaintPositon)),
        DeleteComplaintPosition: (complaintPositon) => dispatch(DeleteComplaintPosition(complaintPositon)),
        clearError: () => dispatch(clearError()),
        throwNewError: (errorType, errorMessage) => dispatch(throwNewError(errorType, errorMessage)),
    };
};

ComplaintPositions.propTypes = {
    complaint: PropTypes.shape({
        complaintType: PropTypes.shape({
            value: PropTypes.string,
            displayName: PropTypes.string
        })
    }),
    fillComplaintPositionByObject: PropTypes.func,
    DeleteComplaintPosition: PropTypes.func,
    openCreateComplaintPositionModal: PropTypes.func,
    goToPreview: PropTypes.func,
    changeComplaintType: PropTypes.func,
    complaintTypes: PropTypes.array,
    positions: PropTypes.array,
    selectedPage: PropTypes.number,
    changeWindowToComplaintPosition: PropTypes.func,
    goToCustomerPage: PropTypes.func,
    clearError: PropTypes.func,
    throwNewError: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintPositions);


// WEBPACK FOOTER //
// ./src/components/ComplaintPositions/ComplaintPositions.js